<div
  class="license"
  [ngClass]="{
    'license--expiring': license.isExpiring,
    'license--expired': license.isExpired,
    'license--used-up': license.isUsedup,
    'license--out-of-bounds': license.isOutofbounds,
    'license--tampered': license.isInvalid,
    'license--future': license.isFuture,
    'license--selected': selected
  }"
>
  <div class="license__total">
    <div class="license__total-wrapper">
      <span>
        <clr-icon shape="user"></clr-icon>
        {{ license.quantity }}
      </span>
    </div>
  </div>

  <ng-content></ng-content>

  <div class="license__header">
    <label class="license__client">{{ license.getDisplayName() }}</label>
    <div class="license__count" *kpdPermission="[Permissions.LicenseRead, Permissions.UserRead]">
      <a
        *ngIf="license"
        class="license__used license__used--link"
        [kpdLinkClick]="license.getDetailUrl()"
        (clickEvent)="clickAssigned($event)"
        >{{ getAssignedText() }}</a
      >
      <label class="license__remaining">{{ getAvailableText() }}</label>
    </div>
    <div class="license__count" *kpdUnlessPermission="['License.Read', 'User.Read']">
      <label class="license__remaining">{{ getAssignedText() }} {{ getAvailableText() }}</label>
    </div>
  </div>

  <div class="license__footer">
    <div
      class="license__state-indicator"
      [ngClass]="{
        'license__state-indicator--info': license.isFuture,
        'license__state-indicator--warning': license.isExpiring,
        'license__state-indicator--danger': license.isExpired || license.isInvalid
      }"
    ></div>
    <label class="license__period">{{ getTermText() }}</label>
    <label class="license__state">{{ getStateText() }}</label>
  </div>
  <label class="license__purchased">{{ getPurchasedText() }}</label>
  <kpd-spinner type="inline" *ngIf="loading" class="license__spinner"></kpd-spinner>
</div>
